import { useState } from 'react';
import { getCookie } from "./authService";

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const useNotificationSettingsServices = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Helper function to make API calls
  const apiCall = async (url, options = {}) => {
    setLoading(true);
    setError(null);
    
    try {
      // Get token from cookie
      const token = getCookie('token');
      
      // Prepare headers with token if available
      const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
      };
      
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      
      const response = await fetch(`${API_BASE_URL}${url}`, {
        headers,
        credentials: 'include', // Include cookies in requests
        ...options,
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Something went wrong');
      }
      
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // Get notification settings
  const getNotificationSettings = async () => {
    return await apiCall('/api/v1/notification-settings');
  };

  // Update notification settings
  const updateNotificationSettings = async (settingsData) => {
    return await apiCall('/api/v1/notification-settings', {
      method: 'PUT',
      body: JSON.stringify(settingsData),
    });
  };

  return {
    getNotificationSettings,
    updateNotificationSettings,
    loading,
    error
  };
};

